export default __webpack_public_path__ + "static/media/Rajagiri-School-Engineering.8b4a369e.jpg";